import { formatNumber, formatPercent, getLocaleNumberSymbol, NumberSymbol } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumberService {
  constructor(
    @Inject(LOCALE_ID) private locale: string,
  ) {}

  public format(value: number | string, locale?: string, digitsInfo?: string, removeSpaces?: boolean): string {
    return this.handleInputValue(
      value,
      value => {
        const formattedValue = formatNumber(value, locale || this.locale, digitsInfo);
        return removeSpaces ? formattedValue.replaceAll(/\s/g, '') : formattedValue;
      }
    );
  }

  public formatPercent(value: number | string, locale?: string, digitsInfo?: string): string {
    return this.handleInputValue(
      value,
      value => formatPercent(value, locale || this.locale, digitsInfo)
    );
  }

  public parse(value: string | number): number {
    const localeNumberSymbol = getLocaleNumberSymbol(this.locale, NumberSymbol.Decimal);
    return Number.parseFloat(String(value).replace(localeNumberSymbol, '.'));
  }

  private handleInputValue(value: number | string, formatter: (value: number) => string): string {
    const numberValue = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(numberValue)) {
      // eslint-disable-next-line no-console
      console.warn('Wrong number format: ', value);
      return String(value);
    }

    return formatter(numberValue);
  }
}
